import type { ButtonHTMLAttributes } from 'react'
import s from './visuals.module.css'

interface AccentButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  arrow?: boolean
}

/** The design system's generous Header-face invitation, for one main action. */
export function AccentButton({ children, arrow = false, className, type = 'button', ...props }: AccentButtonProps) {
  return (
    <button {...props} type={type} className={`${s.accentButton} ${className ?? ''}`.trim()}>
      <span className={s.accentLabel}>{children}</span>
      {arrow ? <span className={s.accentArrow} aria-hidden="true">→</span> : null}
    </button>
  )
}
